<!-- <a mat-button [routerLink]="routerLinkValue"></a> -->
<!-- <a matTooltip="{{this.translate.data['BUTTONVIEWMODEL'] | translate}}"  (click)="viewModels('Modell')">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_view}}</mat-icon>
</a> -->
<!-- <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 13px;" (click)="viewModels('Modell',$event)">Zur Modelansicht</button> -->
<button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 13px;" >Zur Modelansicht</button>

<!-- <a matTooltip="{{this.translate.data['BUTTONVIEWDOCUMENTS'] | translate}}"  (click)="viewModels('Dokumente')">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_doc}}</mat-icon>
</a>
<a matTooltip="{{this.translate.data['BUTTONVIEWTOPICS'] | translate}}"  (click)="viewModels('Topics')">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_topic}}</mat-icon>
</a> -->